import { Component, OnInit } from '@angular/core';
import { ProfileComponent } from './components/profile/profile.component';
import { ImageCarouselComponent } from './components/image-carousel/image-carousel.component';
import { FormButtonsComponent } from './components/form-buttons/form-buttons.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';

@Component({
  selector: 'app-home',
  imports: [
    ProfileComponent, 
    ImageCarouselComponent,
    FormButtonsComponent,
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})

export class HomeComponent {
}